// 📬 Suivi client — signale au serveur un téléchargement PDF / une impression depuis une page publique (jamais bloquant).
const API_URL = (typeof window !== 'undefined' ? window.__API_URL__ : process.env.REACT_APP_BACKEND_URL) || '';

export function enteteAuthPublique() {
  // Un employé connecté qui consulte la page publique envoie son jeton : le serveur ne compte PAS son ouverture.
  const t = typeof window !== 'undefined' && (localStorage.getItem('auth_token') || sessionStorage.getItem('auth_token'));
  return t ? { Authorization: `Bearer ${t}` } : {};
}

export async function signalerEvenementPublic(path, type) {
  try {
    await fetch(`${API_URL}${path}`, { method: 'POST', headers: { 'Content-Type': 'application/json', ...enteteAuthPublique() }, body: JSON.stringify({ type }) });
  } catch {
    /* le suivi ne doit jamais gêner le client */
  }
}
